import Link from 'components/Link/Link';
import Typography from 'components/Typography/Typography';
import styled, { css } from 'styled-components';
import { color, spacer, specific, variable } from 'theme';

const activeState = css`
  color: ${color('primary-400')};
  font-weight: 500;
  background-color: ${color('whisper-100')};
  border-top-left-radius: ${variable('border-radius')};
  border-bottom-left-radius: ${variable('border-radius')};
`;

interface StyledMainCategoryLinkWrapperProps {
  active: boolean;
}

export const StyledMainCategoryLinkWrapper = styled.div<StyledMainCategoryLinkWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacer(50)} ${spacer(300)} ${spacer(50)} ${spacer(100)};
  cursor: pointer;

  &:active,
  &:focus,
  &:hover {
    ${activeState}
  }

  ${({ active }) => active && activeState}
`;

export const StyledSlogan = styled(Typography)`
  color: ${specific('category', 'category-slogan-color')};

  padding: ${spacer(200)} ${spacer(300)} ${spacer(50)} ${spacer(100)};
`;

export const StyledLink = styled(Link)`
  &:active,
  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
